//import React from 'react';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Control, LocalForm, Errors } from 'react-redux-form';
import { Helmet } from 'react-helmet';
import Alert from '../../container/Alert';
import Footer from '../Footer';
import Spinner from "../Snowflake/as/Spinner";
import {Checkbox} from "@material-ui/core";
import ModalExample from "./pop";

const messages1 = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'user.forgotpassword.label.name',
    description: 'Page Header Title',
    defaultMessage: 'Forgot Password'
  },
  headerSubTitle: {
    id: 'empty.label.name',
    description: 'Page Header Subtitle',
    defaultMessage: ' '
  },

  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

const messages2 = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'firsttime.login',
    description: 'Page Header Title',
    defaultMessage: 'Forgot Password'
  },
  headerSubTitle: {
    id: 'onboard.admin.registration',
    description: 'Page Header Subtitle',
    defaultMessage: ' '
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

const print = status => {
  if (status.payload) {
    // console.log(status.payload.response);
    return status.payload.response;
  }
};

class PasswordForgot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMessage: false,
      agreed: false,
      showLicense: this.props.status === 'PENDING_EULA_ACCEPTANCE',
      messages: this.props.status === 'PENDING_EULA_ACCEPTANCE'? messages2 : messages1
    };
  }

  submit= ()=>{
    const license = this.state.showLicense;
    this.setState({showLicense : !license, messages : messages1});
  }

  openModal= ()=>{};
  render() {
    const showMessageTrue = () => {
      this.setState({ showMessage: true });
    };

    return (
      <div className="preview page">
        <Helmet>
          <title>{this.props.intl.formatMessage(this.state.messages.htmlHeader)} - FUSE</title>
        </Helmet>
        <Header
          title={this.props.intl.formatMessage(this.state.messages.headerTitle)}
          subtitle={this.props.intl.formatMessage(this.state.messages.headerSubTitle)}
          icon="preview"
          locale={this.props.locale}
          status = {this.props.status2}
        />

       <ModalExample
          hasTitle
          warning
          warningText = "Error"
          className={this.state.modalsize}
          reset={()=>{}}
          setClick={click => this.openModal = click}
          content={"Re-enter password is not matched."}/>


        {this.state.showMessage && (
          <div className="main">
            <div
              className="panel"
              style={{
                width: '60%',
                padding: '40px',
                boxSizing: 'content-box',
                marginTop: '15px',
                display: 'block',
                alignContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            >
              <div className="form">
                <label
                  style={{
                    width: '90%',
                    fontSize: '16px',
                    textTransform: 'none',
                    lineHeight: '150%'
                  }}
                >
                  You have successfully reset your password.
                </label>
                <br />
                &nbsp;
                <br />
                &nbsp;
                <div className="button-container" style={{ textAlign: 'center' }}>
                  <button
                    className="button"
                    styel={{ padding: 20 }}
                    type="button"
                    onClick={() => this.props.logout()}
                  >
                    <FormattedMessage id="nav.ok" defaultMessage="OK" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {!this.state.showMessage && (
          <div className="main">
            <div
              className="panel"
              style={{
                width: '45%',
                padding: '40px',
                boxSizing: 'content-box',
                marginTop: '15px',
                display: 'block',
                alignContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            >
              {this.state.showLicense && (
                <div>
                  <LocalForm className="agreement">
                    <div className="form">
                      <div
                        style={{
                          fontSize: '20px',
                          textAlign: 'center',
                          fontWeight: 'bold',
                          color: '#1f5c71'
                        }}
                      >
                        END USER LICENSE AGREEMENT
                      </div>
                      <br />

                      <ol>
                        <li>
                          <u>Introduction</u>.<br />
                          You have registered for the use of FUSE<sup>TM</sup>,
                          a proprietary software platform of Next Pathway Inc.
                          (together with its affiliates and subsidiaries, “<b>Company</b>” or “<b>we</b>”)
                          and ancillary services provided by us in connection with FUSE<sup>TM</sup>.
                          (collectively, the “<b>Services</b>”) pursuant to the FUSE STANDARD LICENSE & SERVICES AGREEMENT (“Agreement”).  Your use of the Services is governed by and conditional on your compliance with the applicable terms of the Agreement, as well as these terms of use (together with any other relevant terms and conditions, policies and notices which are provided to you or set out in the Services from time to time, the “<b>Terms</b>”).
                          <br />
                          &nbsp;
                        </li>

                        <li>
                          <u>Acceptance</u>.<br />
                          Please read these Terms carefully to understand your rights and obligations. By accessing or using the Services, you indicate that you understand, accept and agree to be bound by these Terms.
                          <br />
                          &nbsp;
                        </li>
                        <li>
                          <u>Trademarks and Copyright</u>.<br />
                          “FUSE” is a registered trademark of Next Pathway Inc. and may only be used in accordance with these Terms.<br />
                          Unless otherwise expressly set out, all content in the Services is protected by copyrights which are owned and controlled by us or by other parties that have licensed their materials to us. Using our Services does not give you any ownership of our intellectual property rights in the Services, and you may not modify, copy, distribute, transmit, display, perform, reproduce, publish, license, create derivative works from, transfer or sell content obtained from the Services without our written permission.

                          <br />
                          &nbsp;
                        </li>
                        <li>
                          <u>Uploaded Content</u>. <br />
                          By uploading any information or data (“<b>Content</b>”) you warrant that the owner of all applicable rights in and to such Content has expressly granted their permission to have their Content used as required in order to provide the Services, and that the owner of the Content has provided a written consent and acknowledgment thereof.
                          <br />
                          &nbsp;
                        </li>
                        <li>
                          <u>Access Control</u>. <br />
                          The Services may contain technological measures designed to prevent unauthorized or illegal use of the Services. You agree to keep your password confidential and to send us notice immediately if your password has been compromised, or you reasonably believe it may have been compromised. You acknowledge that we have the right, but not the obligation, to monitor all activity relating to the Services and may restrict or suspend your access as necessary to ensure property functioning of the Services and/or enforce your compliance with these terms.
                          <br />
                          &nbsp;
                        </li>
                        <li>
                          <u>Restrictions on Use</u>. <br />
                          You agree to not:
                          <ul style={{ marginLeft: 40 }}>
                            <li type="a">
                              copy the Services, in whole or in part;
                            </li>
                            <li type="a">
                              modify, correct, adapt, translate, enhance or
                              otherwise prepare derivative works or improvements of
                              any part of the Services;
                            </li>
                            <li type="a">
                              rent, lease, lend, sell, sublicense, assign,
                              distribute, publish, transfer or otherwise make
                              available the Services, or parts thereof, to any
                              person, including on or in connection with the
                              internet or any time-sharing, service bureau, software
                              as a service, cloud or other technology or service;
                            </li>
                            <li type="a">
                              reverse engineer, disassemble, decompile, decode or
                              adapt the Services or otherwise attempt to derive or
                              gain access to the source code of the Services, in
                              whole or in part;
                            </li>{' '}
                            <li type="a">
                              bypass or breach any security device or protection
                              used for or contained in the Services;
                            </li>
                            <li type="a">
                              remove, delete, efface, alter, obscure, translate,
                              combine, supplement or otherwise change any
                              trademarks, warranties, disclaimers, or intellectual
                              property rights, proprietary rights or other symbols,
                              notices, marks or serial numbers on or relating to any
                              copy of the Services;
                            </li>
                            <li type="a">
                              use the Services in any manner or for any purpose that
                              infringes, misappropriates or otherwise violates any
                              intellectual property right, privacy right or other
                              right of any person, or that violates any applicable
                              law;
                            </li>
                            <li type="a">
                              use the Services for purposes of: (i) benchmarking or
                              competitive analysis of the Services; or (ii)
                              developing, using or providing a competing software
                              product or service;{' '}
                            </li>
                            <li type="a">
                              use the Services to design, construct, maintain,
                              operate any hazardous environments, systems or
                              applications, any safety response systems or other
                              safety-critical applications or any other use or
                              application in which the use or failure of the
                              Services could lead to personal injury or severe
                              physical or property damage; or
                            </li>
                            <li type="a">
                              use the Services or any deliverables in any manner or
                              for any purpose or application not expressly permitted
                              by these Terms.
                              <br />
                              &nbsp;
                            </li>
                          </ul>
                        </li>

                        <li>
                          <u>Collection and Use of Information</u>. <br />
                          We collect personal information you are required to provide when registering for use of our Services, including your name and email address. We collect and/or process your information when you access and use our Services; and contact us directly (for example, by filling in forms or corresponding with us by email, phone, or otherwise). We collect non-personal information, that does not directly or indirectly reveal your identity or directly relate to an identified individual, such as demographic information, or statistical or aggregated information which does not directly identify a specific person. We may derive non-personal statistical or aggregated data from personal information.
                          <br />
                          We also collect: (a) applicable technical information, including your login information, operating system and platform, or information about your internet connection, the equipment you use to access our Services, and usage details; and (b) non-personal details about your Services interactions, including details contained within support calls and support tickets.
                          <br />
                          We use information that we collect about you or that you provide to us, including any personal information: to present our Services and the contents to you; to carry out our obligations and enforce our rights arising under the Agreement, including for billing and collection or to comply with legal requirements; to notify you about changes to our Services; to improve our Services and end user experiences; and with your consent in any other way we may describe when you provide the information.
                          <br />
                          &nbsp;
                        </li>
                        <li>
                          <u>Disclosure; Transfer; Data Retention</u>. <br />
                          We may disclose personal information you provide to us as described in these Terms: in accordance with applicable law; to our subsidiaries and affiliates; to enforce these Terms; to comply with any court order, law or legal process, including to respond to any governmental or regulatory request, in accordance with applicable law; and if we believe disclosure is necessary or appropriate to protect the rights, property or safety of our organization, our customers, or others.
                          <br />
                          We may process, store, and transfer your personal information in and to a foreign country, with different privacy laws that may or may not be as comprehensive as Canadian law. In these circumstances, the governments, courts, law enforcement, or regulatory agencies of that country may be able to obtain access to your personal information through the laws of the foreign country.
                          <br />
                          Except as otherwise permitted or required by applicable law or regulation, we will only retain your personal information for as long as necessary to fulfill the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements. Under some circumstances we may anonymize your personal information so that it can no longer be associated with you. We reserve the right to use such anonymous and de-identified data for any legitimate business purpose without further notice to you or your consent.
                          <br />
                          &nbsp;
                        </li>
                        <li>
                          <u>Contact Information</u>. <br />
                          If you have any questions regarding these Terms or the collection and use of your personal information, please contact us at:
                          <br />
                          <a href="mailto:contactus@nextpathway.com" style={{color:'#1f5c71'}}>
                            contactus@nextpathway.com
                          </a>
                          <br />
                          &nbsp;
                        </li>
                        <li>
                          <u>Amendment</u>. <br />
                          We reserve the right to modify these Terms at any time and
                          in our sole discretion, provided that we will notify you
                          of any material changes to these Terms.
                        </li>
                      </ol>
                      <br />
                      <br />
                    </div>
                  </LocalForm>
                  <div style={{
                    marginLeft: '-16px'
                  }}>
                    <Checkbox
                      checked={this.state.agreed}
                      color="primary"
                      inputProps={{
                        'aria-label': 'secondary checkbox'
                      }}
                      onChange={()=>{const v= this.state.agreed;this.setState({agreed:!v})}}
                    />

                    <label style={{ display: 'inline', textTransform: 'none' }}>
                      I read through and accept the end user license agreement (EULA).
                    </label>
                  </div>

                  <div className="button-container" style={{ textAlign: 'center' }}>
                    <button className="button" type="submit"
                            onClick={() => {this.submit()}}
                            disabled={!this.state.agreed}
                    >
                      <FormattedMessage
                        id="onboard.next"
                        defaultMessage="Next"
                      />
                    </button>
                  </div>
                </div>
                )}

              {!this.state.showLicense && (
                <LocalForm
                  model="user"
                  onSubmit={({ password,newpassword, renewpassword }) => this.props.changepassword(password,newpassword,renewpassword, this.props.username,showMessageTrue,this.openModal)}
                  className="form"
                >
                  <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="current.password"
                        defaultMessage="Current Password:"
                      />
                    </label>

                    <Control.text model="user.password" type="password" required autoFocus />
                  </fieldset>

                  <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="new.password"
                        defaultMessage="New Password"
                      />
                    </label>

                    <Control.text model="user.newpassword" type="password" required autoFocus />
                  </fieldset>

                  <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="reenter.password"
                        defaultMessage="Re-enter Password"
                      />
                    </label>

                    <Control.text model="user.renewpassword" type="password" required autoFocus />
                  </fieldset>

                  <div className="button-container" style={{ textAlign: 'center' }}>
                    <button className="button" type="submit">
                      <FormattedMessage
                        id="submit.button.name"
                        defaultMessage="Submit"
                      />
                    </button>
                  </div>
                </LocalForm>
              )}

            </div>
          </div>
        )}

        <Footer />
      </div>
    )
  }
}
PasswordForgot.propTypes = {
  forgetpassword: PropTypes.func.isRequired,
  locale: PropTypes.string,
  intl: PropTypes.object,
  username: PropTypes.string
};

export default injectIntl(PasswordForgot);



// WEBPACK FOOTER //
// ./src/components/views/ChangePassword/index.js